import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
    direction: "rtl",
  },
  card: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "4px",
    padding: "16px",
    boxSizing: "border-box",
  },
  summaryCard: {
    width: "100%",
    height: "149px",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "4px",
    padding: "24px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
  },
  sectionsCard: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
    height: "367px",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "4px",
    padding: "24px",
    boxSizing: "border-box",
  },
  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: "16px",
    width: "100%",
    direction: "rtl",
  },
  summaryMetric: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0,
    width: "100%",
    direction: "rtl",
    alignItems: "center",
    justifyContent: "center",
  },
  summaryLabel: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "140%",
    color: theme.palette.text.primary,
    textAlign: "center",
    direction: "rtl",
    width: "100%",
  },
  summaryValue: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "140%",
    color: theme.palette.secondary.main,
    textAlign: "center",
    direction: "rtl",
    width: "100%",
  },
  fieldMetric: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0,
    width: "100%",
    direction: "rtl",
    alignItems: "flex-start",
  },
  fieldLabel: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "140%",
    color: theme.palette.text.primary,
    textAlign: "right",
    direction: "rtl",
    width: "100%",
  },
  fieldValue: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "140%",
    color: theme.palette.secondary.main,
    textAlign: "right",
    direction: "rtl",
    width: "100%",
  },
  grid4: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: "16px",
    width: "100%",
    direction: "rtl",
  },
  grid3: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: "16px",
    width: "100%",
    direction: "rtl",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
  },
  sectionHeader: {
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: "16px",
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
  },
  sectionHeaderPlain: {
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
  },
  sectionTitle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    direction: "rtl",
  },
  profitText: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "140%",
    color: theme.palette.text.secondary,
    textAlign: "center",
    direction: "rtl",
    marginTop: "2px",
    width: "100%",
  },
  inputCard: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "4px",
    padding: "24px",
    boxSizing: "border-box",
  },
  numberedSectionTitle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    direction: "rtl",
    width: "100%",
  },
  grid2: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "16px",
    width: "100%",
    direction: "rtl",
  },
  floorGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: "16px",
    width: "100%",
    direction: "rtl",
    alignItems: "end",
  },
  tyingGrid4: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: "10px",
    width: "100%",
    direction: "rtl",
  },
  equipmentOpenBasketHead: {
    display: "grid",
    gridTemplateColumns: "48px 1fr 88px 2fr",
    height: 52,
    minHeight: 52,
    boxSizing: "border-box",
    backgroundColor: theme.palette.grey[400],
    borderBottom: `1px solid ${theme.palette.divider}`,
    direction: "rtl",
  },
  equipmentOpenBasketBody: {
    display: "grid",
    gridTemplateColumns: "48px 1fr 88px 2fr",
    height: 52,
    minHeight: 52,
    boxSizing: "border-box",
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    direction: "rtl",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  checkboxField: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    minWidth: 0,
    direction: "rtl",
    alignItems: "stretch",
  },
  checkboxLabelSpacer: {
    height: "9.6px",
    margin: 0,
    padding: 0,
    visibility: "hidden",
  },
  checkboxBox: {
    display: "flex",
    flexDirection: "row",
    direction: "rtl",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "8px",
    height: 48,
    width: "100%",
    padding: "12px 16px 12px 8px",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "4px",
    backgroundColor: theme.palette.background.paper,
    boxSizing: "border-box",
  },
  checkboxLabel: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "140%",
    color: theme.palette.secondary.main,
    textAlign: "right",
    direction: "rtl",
  },
  actionRow: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%",
    direction: "rtl",
  },
}));
